import { Stack, StackProps } from "@chakra-ui/react";
import { PropsWithChildren, ReactElement } from "react";

export function MapWrapper({
  children,
  sx,
  ...props
}: PropsWithChildren<StackProps>): ReactElement {
  return (
    <Stack
      sx={{
        ".mapbox-popup-feedback": {
          background: "transparent",
          borderRadius: "lg",
          zIndex: "1000",
        },
        ".mapboxgl-ctrl-logo": {
          display: "none",
        },

        ".mapboxgl-popup-content": {
          p: 0,
          background: "transparent !important",
        },
        ".mapboxgl-ctrl-group": {
          boxShadow: "none",
          borderRadius: "md",
        },

        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
}
